import Vue from 'vue';
import VCalendar from 'v-calendar';

import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

import Calendar from 'v-calendar/lib/components/calendar.umd';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import vuetify from './plugins/vuetify';
import store from './store';
import router from './router';
import App from './App.vue';

// Register components in your 'main'
Vue.component('calendar', Calendar);
Vue.component('date-picker', DatePicker);

Vue.use(VueApollo);
Vue.use(VCalendar, {
  componentPrefix: 'vc',
});
Vue.config.productionTip = false;

const getHeaders = () => {
  const headers = {};
  const token = window.localStorage.getItem('apollo-token');
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};
// Create an http link:
const link = new HttpLink({
  uri: 'https://ipaprev.herokuapp.com/graphql',
  fetch,
  headers: getHeaders(),
});
const client = new ApolloClient({
  link,
  cache: new InMemoryCache({
    addTypename: true,
  }),
});

const apolloProvider = new VueApollo({
  defaultClient: client,
});

new Vue({
  router,
  apolloProvider,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
